import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'am-few-offer',
  styleUrls: ['./few-offer.component.scss'],
  templateUrl: './few-offer.component.html',
})
export class FewOfferComponent implements OnInit {
  @Input()
  public occupancy: number;

  public openAlert = true;

  constructor() {}

  public ngOnInit(): void {}

  public togglesCloseAlert() {
    this.openAlert = false;
  }
}
